import React from 'react';

import { Loading } from '@components/common';
import { UsageTable } from '@components/usage-dashboard/MetricsTable/UsageTable';
import { MetricsTableWrapper } from './styled';

export const MetricsTable: React.FC<{ loading?: boolean }> = ({ loading }) => {
  if (loading) {
    return <Loading />;
  }

  return (
    <MetricsTableWrapper>
      <UsageTable product="EI" />
      <UsageTable product="APP" />
      <UsageTable product="API" />
    </MetricsTableWrapper>
  );
};
